import { type FC } from "react";

import { DetailsHeader } from "../../../../components/sectionHeader";
import { PublishedStatusTypes } from "../../../../enums";
import { type IModalManager } from "../../../../interfaces/IModalManager";
import { type PackView } from "../types/state";

export interface Props {
  pack: PackView;
  packsOverviewUrl: string;
  isValid: boolean;
  handlePublish: () => void;
  handleClose: () => void;
  handleEdit: () => void;
  revertModalManager: IModalManager;
  renderActionButtons: () => React.ReactElement[];
  canBePublished: boolean;
}

export const EditPackDetailsHeader: FC<Props> = (props: Props) => {
  return (
    <DetailsHeader
      title={props.pack.title}
      titleForGA="Pack Details"
      backButton={props.packsOverviewUrl}
      defaultURL={props.packsOverviewUrl}
      canBeEdited={!props.pack.isDraft}
      isRevertVisible={props.pack.hasBeenPublished}
      canBePublished={props.canBePublished}
      publishedStatus={PublishedStatusTypes.ConvertToPublishedStatusType(!props.pack.isDraft)}
      invalidFormDetails={!props.isValid}
      entityStateActions={{
        onPublish: props.handlePublish,
        onClose: props.handleClose,
        onEdit: props.handleEdit,
        onRevert: props.revertModalManager.execute,
      }}
      actionButtons={props.renderActionButtons()}
    />
  );
};

export default EditPackDetailsHeader;
